import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from "reactstrap";

import Breadcrumbs from 'components/Common/Breadcrumb';
import TableContainerV1 from "components/Common/TableContainerV1";
import { deletePromotion, getPromotionList } from "helpers/UAM/promotion.helper";
import { formatDateString } from "common/utility";
import ToastDialog from "components/Common/ToastDialog";
import { useToast } from "ToastStore";
import DeleteModal from "components/Common/DeleteModal";
import Switch from "react-switch";


const Offsymbol = () => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                fontSize: 12,
                color: "#fff",
                marginRight:'10px'
            }}
        >
            {" "}
            Inactive
        </div>
    );
};

const OnSymbol = () => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                fontSize: 12,
                color: "#fff",
                marginLeft:'10px'
            }}
        >
            {" "}
            Active
        </div>
    );
};

const TableActionsComponentToggle = (props, handleChange) => {
    const [checked, setChecked] = useState(props.isActive);
    const newObj = {};
    for (const key in props) {
        if (props[key] !== null) {
            newObj[key] = props[key];
        }
    }
    useEffect(() => {
        setChecked(props.isActive)
    }, [props]);
    return (
        <UncontrolledDropdown>
            <DropdownToggle tag="a" className="card-drop">
                <Switch
                    uncheckedIcon={<Offsymbol />}
                    checkedIcon={<OnSymbol />}
                    className="me-1 mb-sm-8 mb-2"
                    onColor="#344fa0"
                    width={80}
                    onChange={() => {
                        newObj.isActive = !props.isActive
                        props.isActive = !props.isActive
                        setChecked(newObj.isActive)
                        handleChange(newObj);
                    }}
                    checked={checked}
                    />
            </DropdownToggle>
        </UncontrolledDropdown>
    )
}


const TableActionsComponent = (props, handleDeletePromocode=null) => {
  const navigate = useNavigate();
  const { roleName } = JSON.parse(localStorage.getItem("user"))

  const navigateToViewPromocode = (id) => {
    const encryptedId = btoa(id.toString());
    navigate(`/${roleName}/viewPromocode?id=${encodeURIComponent(encryptedId)}`);
  };

  const navigateToEditPromocode = (id) => {
    const encryptedId = btoa(id.toString());
    navigate(`/${roleName}/editPromocode?id=${encodeURIComponent(encryptedId)}`);
  };

  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="a" className="card-drop">
        <i className="mdi mdi-dots-horizontal font-size-18"></i>
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu-end">
        <DropdownItem
          onClick={() => {
            navigateToViewPromocode(props.id);
          }}
        >
          <i
            className="mdi mdi-eye font-size-16 text-success me-1"
            id="viewtooltip"
          ></i>
          View
          <UncontrolledTooltip placement="top" target="viewtooltip">
            View
          </UncontrolledTooltip>
        </DropdownItem>

        <DropdownItem
          onClick={() => {
            navigateToEditPromocode(props.id);
          }}
        >
          <i
            className="mdi mdi-pencil font-size-16 text-success me-1"
            id="edittooltip"
          ></i>
          Edit
          <UncontrolledTooltip placement="top" target="edittooltip">
            Edit
          </UncontrolledTooltip>
        </DropdownItem>

        <DropdownItem
          onClick={() => handleDeletePromocode(props.id)}>
          <i className="mdi mdi-trash-can font-size-16 text-danger me-1" id="deletetooltip"></i>
          Delete
          <UncontrolledTooltip placement="top" target="deletetooltip">
            Delete
          </UncontrolledTooltip>
        </DropdownItem>

      </DropdownMenu>
    </UncontrolledDropdown>
  )
}


const PromotionList = (props) => {
  document.title = "Promocode List | DMS";

  const navigate = useNavigate();
  const [promotionList, setPromotionList] = useState([]);
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  });
  const [pageSize, setPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [columnId, setColumnId] = useState("id");
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
  const [sortingOptions, setSortingOptions] = useState({
    column: "id",
    isAsc: false,
    optionalColumn: ["Action"],
  });

  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null)
  const { roleName } = JSON.parse(localStorage.getItem("user"))

  const columns = useMemo(
    () => [
      {
        Header: 'Promotion Code',
        accessor: 'promotionCode',
        filterable: true,
        Cell: (cell) => {
          return cell.value ? cell.value : '';
        }
      },
      {
        Header: 'Description',
        accessor: 'description',
        filterable: true,
        Cell: (cell) => {
          return cell.value ? cell.value : '';
        }
      },
      {
        Header: 'Start Date',
        accessor: 'startDate',
        filterable: true,
        Cell: (cell) => {
          return cell.value ? cell.value : '';
        }
      },
      {
        Header: 'End Date',
        accessor: 'endDate',
        filterable: true,
        Cell: (cell) => {
          return cell.value ? cell.value : '';
        }
      },
      {
        Header: 'Status',
        accessor: 'isActive',
        filterable: true,
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          return TableActionsComponentToggle(rowData, handleChange);
      },
      },
      {
        Header: 'Discount',
        accessor: 'discount',
        filterable: true,
        Cell: (cell) => {
          return cell.value ? cell.value : '';
        }
      },
      {
        Header: 'Action',
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          return TableActionsComponent(rowData, handleDeletePromocode);
        }
      },
    ],
    []
  );

  const handleDeletePromocode = (id) => {
    setDeleteItemId(id)
    setDeleteModal(true)
  }
  const deletePromocode = () => {
    deletePromotion({deleteItemId})
    .then(responseFromAPI => {
      if(responseFromAPI.status) {
        setToastInfo({
          message: responseFromAPI.message,
          showToast: true,
          role: "success",
        });
        setDeleteModal(false)
        getPromocodeList({})
      }
    })
    .catch(error => {})
  };

  const getPromocodeList = data => {
    getPromotionList(data)
      .then(responseFromAPI => {
        if (responseFromAPI.status && responseFromAPI.code == 200) {
          let formatedData = responseFromAPI.data.data.map(promoItem => {
            promoItem.startDate = formatDateString(
              promoItem.startDate
            );
            promoItem.endDate = formatDateString(
              promoItem.endDate
            );
            promoItem.discount = `${promoItem.discount}%`
            return promoItem;
          })
          setPromotionList(formatedData)
          const { totalItems, totalPages, currentPage } = responseFromAPI.data
          if(formatedData.length>0){
            setPagination({
              pageIndex: currentPage,
              pageCount: totalPages,
              totalRecords: totalItems,
            })
          }else{
            setPagination({
              pageIndex: 0,
              pageCount: 0,
              totalRecords: 0,
            })
          }
        } else {
          setPromotionList([])
        }
      })
      .catch(error => { })
  }

  const handlePageChange = (page, pageSize, searchKey, columnName = columnId, sortingOrder = sortingOrderStatus) => {
    setPageSize(pageSize);
    getPromocodeList({ page, limit: pageSize, searchKey, columnName, sortingOrder })
  }

  const handleSortColumn = (option) => {
    setSortingOptions(option);
    const columnName = option.column;
    setColumnId(columnName);
    const sortingOrder = option.isAsc ? "asc" : "desc";
    setSortingOrderStatus(sortingOrder);
    handlePageChange(1, pageSize, searchValue, columnName, sortingOrder);
  };

  const handleSearchFilter = (value, pageSize) => {
    setSearchValue(value);
    handlePageChange(1, pageSize, value);
  };
  const handleClearSearch = () => {
    setSearchValue("");
    handlePageChange(1, pageSize, "");
  };

  useEffect(() => {
    getPromocodeList({})
  }, []);

  const handleCustomerClicks = () => {
    navigate(`/${roleName}/addPromocode`);
  };

  const handleChange = (data) => {
    deletePromotion({ deleteItemId: data.id, isActive: data.isActive, isActiveFlag: true })
      .then(responseFromAPI => {
        if (responseFromAPI.status) {
          if(data.isActive){
            setToastInfo({
              message: 'Promotion Activated',
              showToast: true,
              role: "success",
            });
          }else{
            setToastInfo({
              message: 'Promotion Deactivated',
              showToast: true,
              role: "success",
            });
          }
          setDeleteModal(false)
          getPromocodeList({})
        }
      })
      .catch(error => { })
  };

  const buttonSection = (
    <div className="text-sm-end">
      <Button
        type="button"
        color="success"
        className="btn-rounded mb-2 me-2"
        onClick={handleCustomerClicks}
      >
        <i className="mdi mdi-plus me-1" />
        {'Add Promocode'}
      </Button>
    </div>
  );

  return (
    <div className="page-content">
      <Breadcrumbs title="Promotions" breadcrumbItem="Promotion List" />
      <Container fluid>
        <Row className="vertical-scroll">
          <Col xs="12">
            <Card>
              <CardBody>
                <TableContainerV1
                  columns={columns}
                  data={promotionList}
                  pagination={pagination}
                  handlePageChange={handlePageChange}
                  handleSearchFilter={handleSearchFilter}
                  customSection={buttonSection}
                  sortOptions={sortingOptions}
                  handleSortColumn={handleSortColumn}
                  handleClearSearch={handleClearSearch}
                  className="custom-header-css"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      <DeleteModal
        show={deleteModal}
        onDeleteClick={deletePromocode}
        onCloseClick={() => setDeleteModal(false)}
      />

      <ToastDialog
        message={toastInfo.message}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      />
    </div>
  );
};

export default PromotionList;
